import { useCallback } from 'react';
import { useIsRemediation } from './useIsRemediation';

// Remediation organizations speak of equipment as "On-JobSite" (left behind at
// a job site) and "At-Home" (not tracked, back at the yard). Every other
// vertical market, roll-off and container organizations included, keeps the
// long-standing labels: term() hands their label back unchanged.
const REMEDIATION_TERMS: Record<string, string> = {
  'Left Behind': 'On-JobSite',
  'Left Onsite': 'On-JobSite',
  'Left OnSite': 'On-JobSite',
  'On Site': 'On-JobSite',
  Tracked: 'On-JobSite',
  'Not Tracked': 'At-Home',
  'At Home': 'At-Home',
  'On Road': 'On-Road',
};

export const useMarketTerm = (): ((label: string) => string) => {
  const isRemediation = useIsRemediation();
  return useCallback((label: string) => (isRemediation ? REMEDIATION_TERMS[label] ?? label : label), [isRemediation]);
};
